module.exports = __webpack_public_path__ + "static/media/zapsplat_office_pen_biro_ball_point_tap_001_49692.fe241180.wav";